import { Link } from "@tanstack/react-router";
import { ArrowLeft, Construction } from "lucide-react";
import { PageHeader } from "@/components/page-header";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function PlaceholderPage({
  title,
  description,
  milestone,
  bullets,
}: {
  title: string;
  description: string;
  milestone: string;
  bullets: string[];
}) {
  return (
    <div className="space-y-6">
      <PageHeader
        title={title}
        description={description}
        actions={
          <Button asChild variant="outline">
            <Link to="/">
              <ArrowLeft className="h-4 w-4" />
              返回工作台
            </Link>
          </Button>
        }
      />
      <Card>
        <CardHeader className="items-start">
          <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-amber-50 text-amber-600">
            <Construction className="h-5 w-5" />
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <CardTitle>该模块按里程碑交付</CardTitle>
            <Badge variant="warning">{milestone}</Badge>
          </div>
          <CardDescription>
            M1 先交付可登录、可鉴权、可审计的地基；本页面的业务能力将在后续里程碑接入。
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="grid gap-2 text-sm text-muted-foreground">
            {bullets.map((bullet) => (
              <li key={bullet} className="flex gap-2">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary/60" />
                {bullet}
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
